module.exports = __webpack_public_path__ + "static/Mini-029d59dc7b6e1c2541eeacec391fd41a.png";